import type { UIMessage } from '@ai-sdk/react';
import type { ChatStatus } from 'ai';
import { createContext, useContext } from 'react';
import type { AIChatMarkdownComponents, AIChatMarkdownVariant } from '../AIChatMarkdown';

export type AIChatMessagesContextValue = {
  isDebug: boolean;
  lastMessageId?: string;
  messages: UIMessage[];
  status: ChatStatus;
  markdownComponents?: AIChatMarkdownComponents;
  markdownVariant: AIChatMarkdownVariant;
  messageContentClassName: string;
  hideAssistantMessage: boolean;
  hideAvatar: boolean;
  hideReasoning: boolean;
  hideTools: boolean;
  hideUserMessage: boolean;
  onRegenerate: () => void;
  source: string;
};

export const AIChatMessagesContext = createContext<AIChatMessagesContextValue | null>(null);

export const useAIChatMessagesContext = () => {
  const ctx = useContext(AIChatMessagesContext);
  if (!ctx) throw new Error('AIChatMessages subcomponents must be used inside <AIChatMessages>');
  return ctx;
};
